var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 comp-admin-organization-level my-3"},[_c('adminnavigation',{attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }